import type { PropsWithChildren } from "react";
import { IoChevronDown } from "react-icons/io5";

import { Select as RSelect } from "radix-ui";

import { cn } from "shared/utils/cn";

import { Field } from "./field";

type Props = {
  className?: string;
  value?: string;
  placeholder?: string;
} & RSelect.SelectProps;

export const Select = (props: PropsWithChildren<Props>) => {
  const { className, value, placeholder, children, ...rootProps } = props;
  return (
    <RSelect.Root {...rootProps}>
      <RSelect.Trigger asChild>
        <Field
          className={cn(
            "group outline-hidden data-[state=open]:border-white",
            className
          )}
          as="button"
        >
          <RSelect.Value
            className={cn(!value && "text-pale-grey")}
            placeholder={placeholder}
          />
          <RSelect.Icon className="absolute top-1/2 right-3 -translate-y-1/2 transition-transform group-data-[state=open]:rotate-180">
            <IoChevronDown />
          </RSelect.Icon>
        </Field>
      </RSelect.Trigger>
      <RSelect.Portal>
        <RSelect.Content
          position="popper"
          sideOffset={0}
          collisionPadding={10}
          side="bottom"
          align="start"
          alignOffset={0}
          className="border-dark-grey max-h-70dvh w-full min-w-xs rounded-xl border bg-black px-0 py-3"
        >
          <RSelect.Viewport>{children}</RSelect.Viewport>
        </RSelect.Content>
      </RSelect.Portal>
    </RSelect.Root>
  );
};

export const SelectItem = ({
  className,
  children,
  ...props
}: RSelect.SelectItemProps) => {
  return (
    <RSelect.Item
      className="cursor-pointer px-3 py-5 leading-5.5 tracking-[0.4px] text-white outline-hidden first:pt-0 last:pb-0 hover:brightness-90 active:brightness-90"
      {...props}
    >
      <RSelect.ItemText>{children}</RSelect.ItemText>
    </RSelect.Item>
  );
};
